import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {Table} from '../../../common/model/table.model';
import {CommonService} from '../../../common/controller/common.service';

@Component({
    selector: 'app-list-layout',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <div class="row">
      <div class="container">

        <div *ngIf="loading ; else results_table" style="text-align: center;">
          Caricamento ...
          <i class="fa fa-spinner fa-pulse fa-fw"></i>
        </div>

        <ng-template #results_table>
          <div *ngIf="count > 0; else nessun_item" >

            <ul class="list-group" [ngClass]="classForDisplayList()">
              <ng-content></ng-content>
            </ul>

            <table *ngIf="table" class="table table-hover table-bordered table-light" [ngClass]="classForDisplayTable()">
              <thead class="table-secondary">
              <th *ngFor="let key of table.keys"> {{ key | translate }}</th>
              </thead>
              <tbody>
              <tr *ngFor="let row of table.rows" app-table-item (delete)="onDelete($event)" [noEdit]="noEdit"
                  [queryparams]="queryparams" [keys]="table.keys" [row]="row" [hasEditValidita]="hasEditValidita"
                  [hasEditValoreAttributo]="hasEditValoreAttributo"
                  [serviceAttachment]="serviceAttachment" [uploadEnabledAttachment]="uploadEnabledAttachment" 
                  [deleteEnabledAttachment]="deleteEnabledAttachment" [openModal]="openModal"
                  (openEditModal)="innerOpenEditModal($event)" (openShowModal)="innerOpenShowModal($event)">
              </tr>
              </tbody>
            </table>
          </div>
        </ng-template>

        <!-- Paging -->
        <div class="row pt-1">
          <div class="col-md-6">
            <pagination 
              *ngIf="count > page_offset"
              [boundaryLinks]="true" 
              [totalItems]="count"  
              [maxSize]="5" 
              (pageChanged)="pageChanged($event)"
              previousText="&lsaquo;" 
              nextText="&rsaquo;" 
              firstText="&laquo;" 
              lastText="&raquo;">
            </pagination>
          </div>  
          <div class="col-md-6">
            <!-- Recap -->
            <div *ngIf="count > 0" class="d-inline-block float-right" [ngClass]="{'mt-3': showPage && count > page_offset}">
              <small>
              {{ 'present' | translate }} <span class="font-weight-bold">{{ count }}</span> {{ 'occurrences' | translate }}.
                  {{ 'shown_from' | translate }} {{ showFrom() }} {{ 'shown_to' | translate }} {{ showTo() }}.
              </small>
            </div>
          </div>
        </div>  
        <ng-template #nessun_item style="text-align: center;"> {{ 'no_item' | translate }}</ng-template>

      </div>
    </div>
    `,
    styles: [`.loadingmask tr { color: lightgray ; }`],
    standalone: false
})
export class ListLayoutComponent {

  @Input() table: Table = null;

  @Input() loading : boolean;

  @Input() items = [];

  @Input() page: 0;

  @Input() count = 0;

  @Input() queryparams = {};

  @Input() hasEditValidita = false;

  @Input() hasEditValoreAttributo = false;

  @Input() serviceAttachment: CommonService<any>;

  @Input() uploadEnabledAttachment: boolean = true;

  @Input() deleteEnabledAttachment: boolean = true;

  @Input() noEdit = false;

  @Output() onChangePage = new EventEmitter();

  @Output() delete = new EventEmitter();

  @Input() openModal: boolean = false;

  @Output() openEditModal = new EventEmitter();

  @Output() openShowModal = new EventEmitter();

  @Input() showPage: boolean = true;

  @Input() page_offset = CommonService.PAGE_OFFSET;

  pageChanged(event: any): void {
    this.onChangePage.emit(event.page-1);
  }

  public classForDisplayList() {
    if (this.table) {
      return {
        'd-block': true,
        'd-md-none': true
      };
    }
    return {};
  }

  public classForDisplayTable() {
    if (this.table) {
      return {
        'd-none': true,
        'd-md-table': true
      };
    }
    return {};
  }

  public onDelete(event) {
    this.delete.emit(event);
  }

  public showFrom() {
    return this.page * this.page_offset + 1;
  }

  public showTo() {
    const to = this.showFrom() + this.page_offset;
    return to > this.count ? this.count : to - 1;
  }

  innerOpenEditModal(entity): void {
    this.openEditModal.emit(entity);
  }

  innerOpenShowModal(entity): void {
    this.openShowModal.emit(entity);
  }
}

